<template>
  <div class="flex flex-row" id="app">
    <div class="fixed h-screen z-10">
      <Mqttbox></Mqttbox>
      <div v-show="sidebarShow">
      <Sidebar @collapsed-change="onSidebarCollapsedChange"></Sidebar>
      </div>
    </div>

    <!-- 主內容區域，增加左邊距以避免被側邊欄覆蓋 -->
    <div :class="[sidebarShow ? (sidebarCollapsed ? 'ml-20' : 'ml-64') : 'ml-0', 'flex-1 w-full overflow-y-auto min-h-screen transition-all duration-300']">
      <router-view />
    </div>
  </div>
</template>

<script>
import Mqttbox from './components/Mqttbox.vue'
import Sidebar from './components/Sidebar.vue'
// import Header from './components/Header.vue'

export default {
  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      collapsed: false,
      sidebarShow: true,
      sidebarCollapsed: false
    }
  },
  components: {
    Mqttbox,
    Sidebar
    // Header
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.name === 'LogIn') {
          this.sidebarShow = false
        } else {
          this.sidebarShow = true
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.GetDeviceList()
  },
  methods: {
    toggleCollapsed () {
      this.collapsed = !this.collapsed
    },
    onSidebarCollapsedChange (collapsed) {
      this.sidebarCollapsed = collapsed
    },
    GetDeviceList () {
      this.axios
        .post(this.baseURL + this.basePort + '/device/deviceList', {})
        .then((res) => {
          console.log(res.data)
          if (res.data.message === 'success') {
            this.$store.commit('deviceList', res.data.data)
          } else {
          }
        })
        .catch((error) => {
          // 處理上傳失敗的回應
          console.error(error)
        })
    }
  }
}
</script>
<style lang="css">
</style>
